<footer id="footer" [ngStyle]="{'width.px': windowWidth}">
  <div>CPSC Analytics</div>
  <div>&copy; {{copyRightYear}} AAMC-Vizient Inc. All Rights Reserved</div>
  <div *ngIf="fromPdf">CPT® only © {{copyRightYear - 1}} American Medical Association. All Rights Reserved.</div>
</footer>
